import { render, staticRenderFns } from "./CurrentSignature.vue?vue&type=template&id=2ac1412a"
import script from "./CurrentSignature.vue?vue&type=script&lang=js"
export * from "./CurrentSignature.vue?vue&type=script&lang=js"
import style0 from "./CurrentSignature.vue?vue&type=style&index=0&id=2ac1412a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports